<template>
  <transition name="fade">
    <div v-if="modelValue" class="fixed z-[1200] inset-0 overflow-y-auto">
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <!-- Dialog -->
      <div class="flex items-center justify-center min-h-screen p-4">
        <div 
          class="relative bg-white rounded-xl shadow-xl max-w-md w-full p-6 transform transition-all"
          @click.stop
        >
          <!-- Icon -->
          <div class="mb-4">
            <div 
              class="mx-auto flex items-center justify-center h-12 w-12 rounded-full"
              :class="{
                'bg-red-100': type === 'danger',
                'bg-yellow-100': type === 'warning',
                'bg-blue-100': type === 'info'
              }"
            >
              <span 
                class="material-symbols-outlined text-2xl"
                :class="{
                  'text-red-600': type === 'danger',
                  'text-yellow-600': type === 'warning',
                  'text-blue-600': type === 'info'
                }"
              >
                {{ icon }}
              </span>
            </div>
          </div>

          <!-- Content -->
          <div class="text-center">
            <h3 class="text-lg font-medium text-gray-900 mb-2">
              {{ title }}
            </h3>
            <p class="text-sm text-gray-500">
              {{ message }}
            </p>
          </div>

          <!-- Actions -->
          <div class="mt-6 flex justify-end space-x-3">
            <button
              v-if="showCancel"
              @click="$emit('update:modelValue', false)"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {{ cancelText }}
            </button>
            <button
              @click="confirm"
              class="px-4 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2"
              :class="{
                'bg-red-600 hover:bg-red-700 focus:ring-red-500': type === 'danger',
                'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500': type === 'warning',
                'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500': type === 'info'
              }"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppConfirmDialog',
  props: {
    modelValue: Boolean,
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'danger',
      validator: (value) => ['danger', 'warning', 'info'].includes(value)
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'warning'
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      this.$emit('update:modelValue', false);
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
